import { useTranslation } from 'react-i18next';
import React, {useState, useEffect, useCallback} from 'react';
import {httpGet, httpPost} from '../shared/Config';
import {Button} from 'reactstrap';
import SimpleModal from "../shared/SimpleModal";
import ConfirmationModal from '../shared/ConfirmationModal';
import MoneyFormat from '../shared/MoneyFormat';

function ShoppingCartConfirmationModal({isOpen, onCancel, onOk, title, paymentType, total, ivaInclude, currency}) {

    const {t} = useTranslation();

    const [shoppingCartItems, setShoppingCartItems] = useState([]);
    const [allowPurchase, setAllowPurchase] = useState(false);
    const [error, setError] = useState("");
    const [showConfModal, setShowConfModal] = useState(false);

    function handleConfCancel() {
        setShowConfModal(false);
    }

    function handleSpeiPurchaseClick() {
        if (showConfModal) {
            try{
                setAllowPurchase(false);
                if(paymentType === "SPEI") {
                    async function purchaseCart() {
                        const response = await httpPost('/payments/purchaseShoppingCart', {
                            purchaseMethod: 'SPEI'
                        });
            
                        if(response) {
                            setAllowPurchase(true);
                            setShowConfModal(false);
                            onOk();
                            fetchShoppingCart();   
                        }
                    }
                    purchaseCart();
                }
            } catch(e) {
                setAllowPurchase(true);
                setShowConfModal(false);
            }

        }
    }

    const fetchShoppingCart = useCallback(async () => {
        const response = await httpGet(`/shoppingCart/getShoppingCart`);
        setShoppingCartItems(response.data);

        if(response.data) {
            setAllowPurchase(true);
        }
    },[])
    useEffect(() => {
        if(isOpen) {
            fetchShoppingCart();    
        }
    }, [isOpen]);

    async function onOkClick() {
        if(paymentType === "SPEI") {
            setShowConfModal(true);
        } else if(paymentType === "Stripe0") {
            async function purchaseCartStripe() {
                const response = await httpPost('/payments/purchaseShoppingCartStripe', {
                    purchaseMethod: 'Stripe0'
                });
    
                if (response.data.error) {
                    setError(response.data.error);
                } else if(response.data.checkoutUrl) {
                    window.location.href = response.data.checkoutUrl;
                }
            }
            purchaseCartStripe();
        }
    }    
    
    function onCancelClick() {
        setAllowPurchase(false);
        onCancel();
    }

    return (
        <SimpleModal isOpen={isOpen}>
            <h3>
                {t(title)}
            </h3>
            <div>
            <hr className='m-5' />
            {
                shoppingCartItems ? <React.Fragment>
                    {
                        shoppingCartItems.map((item,i) => (
                            <div style={{marginTop: '10px'}}>
                                {t(item.translateTag)}
                                <br/> 
                                {t('AMOUNT_OF')}: {item.amount}
                                <br/>
                                {
                                    paymentType === "SPEI" ? <React.Fragment>{t('Amount')}: <MoneyFormat>{item.totalIvaSpei}</MoneyFormat> { currency }</React.Fragment> : null
                                }                                
                                {
                                    paymentType === "Stripe0" ? <React.Fragment>{t('Amount')}: <MoneyFormat>{item.totalIvaStripe}</MoneyFormat> { currency }</React.Fragment> : null
                                }
                            <hr className='m-5' />
                            </div>
                            ))
                    }
                </React.Fragment> : null
            }                     
            {
                paymentType === "SPEI" ? <React.Fragment>
                    <div style={{marginBottom: '2%', fontWeight: 'bold', color: 'red'}}>
                        {t('SPEI_NOTICE1', {
                            paymentMethod: 'SPEI',
                            unverifiedPercent: '10%',
                            buyType: t("documentos"),
                            maxPercent: '50'
                        })}
                    </div>
                </React.Fragment> : null
            }            
            {t('Payment method')}:
            {
                paymentType === "SPEI" ? <React.Fragment>
                    <span> SPEI</span>
                </React.Fragment> : <React.Fragment>
                    <span style={{marginLeft: '5px'}}>{t('PAY_WITH_CARD')}</span>
                </React.Fragment>
            }
            {
                paymentType === "SPEI" && ivaInclude ? <React.Fragment>
                    <br/>
                    <span style={{fontWeight: 'bold'}}>{t('SPEI_TRANSFER_DISCOUNT_NOTICE')}</span>
                    <br/>
                </React.Fragment> : null
            }      
            <br/>
            {t('TOTAL_PRICE')} <MoneyFormat>{total}</MoneyFormat> { currency }
            <br/>
            </div>
            <div className={'modal-action'}>
                <Button disabled={shoppingCartItems.length <= 0} className={'btn btn-primary'} color="primary" onClick={onOkClick}>{
                    paymentType === "SPEI" ? <div>{t('PAY')}</div> : <div>{t('PROCEED_TO_PAYMENT')}</div>
                }</Button>
                <Button className={'btn'} color="secondary" onClick={onCancelClick}>{t('CANCEL')}</Button>
            </div>
            <ConfirmationModal isOpen={showConfModal}
                               onCancel={handleConfCancel}
                               onOk={handleSpeiPurchaseClick}
                               title="CONFIRM_SHOPPING_CART">
                <p>{t('CONFIRM_SPEI_SHOPPING_CART')}</p>
                <p>{t('CONTINUE_QUESTION')}</p>
            </ConfirmationModal>

        </SimpleModal>
    )
}

export default ShoppingCartConfirmationModal;
